import React from 'react'

interface Props {
    header: string;
    value: string;
}

export default function RaporCard(props: Props) {
    return (
        <div style={{ width: '100%', height: '100%', backgroundColor: 'gray' }}>
            <div style={{ width: '100%', height: '50%', backgroundColor: '#b68a33', display: 'flex', justifyContent: 'center', alignItems: 'center', fontFamily: "'Lucida Grande', 'Lucida Sans Unicode', Arial, Helvetica, sans-serif", fontSize: '16px' }}>{props.header}</div>
            <div style={{ width: '100%', height: '50%', backgroundColor: '#60471c', display: 'flex', justifyContent: 'center', alignItems: 'center', fontFamily: "'Lucida Grande', 'Lucida Sans Unicode', Arial, Helvetica, sans-serif", fontSize: '16px' }}>{props.value}</div>
        </div>
    )
}
